import React, { useMemo } from 'react';

import { defaultSpecialCard } from '../../constants';
import { useDiscountWizardStateContext } from '../../state';
import {
  PreviewSection,
  IndividualSpecialPreviewTextContainer,
  PreviewTitle,
  PreviewDescription,
  SpecialsCardContainer,
  SpecialsCardShopButton,
} from '../online-details/styled';

import { OnlineDetailsImagePreviewWrapper } from './styled';
import { SummaryCard } from './summary-card';

import type { SummaryCardProps } from './summary-card';

export function OnlineDetailsCard({ onEditClick }: { onEditClick: () => void }) {
  const {
    onlineDetailsStepState: { description, onlineName, imageUrl },
  } = useDiscountWizardStateContext();

  const rows = useMemo(() => {
    const rows: SummaryCardProps['rows'] = [
      { fieldTitle: 'Online name', fieldValue: onlineName },
      {
        fieldTitle: 'Preview',
        fieldValue: (
          <OnlineDetailsImagePreviewWrapper>
            <PreviewSection>
              <IndividualSpecialPreviewTextContainer $imageUrl={imageUrl ?? defaultSpecialCard}>
                <PreviewTitle>{onlineName}</PreviewTitle>
                {description !== '' && <PreviewDescription>{description}</PreviewDescription>}
              </IndividualSpecialPreviewTextContainer>
            </PreviewSection>
            <PreviewSection>
              <SpecialsCardContainer $imageUrl={imageUrl ?? defaultSpecialCard}>
                <PreviewTitle>{onlineName}</PreviewTitle>
                <SpecialsCardShopButton>Shop</SpecialsCardShopButton>
              </SpecialsCardContainer>
            </PreviewSection>
          </OnlineDetailsImagePreviewWrapper>
        ),
      },
    ];

    return rows;
  }, [description, imageUrl, onlineName]);

  return <SummaryCard rows={rows} title='Online details' onEditClick={onEditClick} />;
}
